export const documentationSchema = {
  title: "Documentation",
  type: "object",
  required: ["documentationSection0"],
  properties: {
    documentationSection0: {
      type: "object",
      title: "Documentation",
      description: "Please indicate which documents you will provide",
      properties: {
        documentMPOA: {
          type: "boolean",
          title: "Medical Power of Attorney (MPOA)",
        },
        documentDNR: {
          type: "boolean",
          title: "Out Of Hospital DNR (Do Not Resuscitate)",
        },
        dnrLocation: {
          type: "string",
          title: "Location of DNR Document",
          maxLength: 100,
          errorMessage: {
            maxLength: "Location must be at most 100 characters.",
          },
        },
      },
    },
  },
};

export const documentationUiSchema = {
  documentationSection0: {
    "ui:field": "DocumentationField",

    documentMPOA: { "ui:md": 6 },
    documentDNR: { "ui:md": 6 },
    dnrLocation: { "ui:md": 6 },
  },
};
 